import { render, staticRenderFns } from "./ScientificProductionTable.vue?vue&type=template&id=c8e51ad6&"
import script from "./ScientificProductionTable.vue?vue&type=script&lang=js&"
export * from "./ScientificProductionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports